import {DeleteRecordsConfirmationButton,} from '@flexinet/ui-components';

import {useRegistrations} from '../hooks/useRegistrations.ts';
import {useRegistrationsSelection} from "../hooks/useRegistrationsSelection.ts";

export const DeleteRecordButton = () => {

    const {deleteRecords} = useRegistrations();

    const {
        selection,
        handleClearSelection,
    } = useRegistrationsSelection();

    const recordIds = Object.keys(selection);
    let disabled = true;
    if (recordIds.length > 0) {
        disabled = false;
    }


    return (<DeleteRecordsConfirmationButton
        disabled={disabled}
        recordIdsLength={recordIds.length}
        handleConfirm={() => {
            deleteRecords()
            handleClearSelection()
        }}/>);
};
